<template>
<div id="product-side-menu" class="menu">
    <h2 class="menu-label">
        <router-link v-if="upper && (upper.slug || upper.url.rtrim('/') != this.$route.fullPath.rtrim('/'))" :to="upper.url ? upper.url : make_url(upper.slug)">←</router-link> {{title}}
    </h2>
    <ul class="menu-list" v-if="menu && menu.length > 0">
        <li v-for="item in menu" :class="{'has-sub-menu': item.sub && item.sub.length > 0}">
            <router-link :to="item.url ? item.url : make_url(item.slug)">{{item.title}}</router-link>
            <button
                :class="['button', {'is-expanded': item.active}]"
                v-if="item.sub && item.sub.length > 0"
                @click.prevent="item.active = !item.active"
            >
                <i class="fas fa-angle-right"></i>
            </button>
            <ul :class="{'is-expanded': item.active}" v-if="item.sub && item.sub.length > 0">
                <li v-for="subitem in item.sub">
                    <router-link :to="make_url(subitem.slug)">{{subitem.title}}</router-link>
                </li>
            </ul>
        </li>
    </ul>
</div>
</template>

<script>
export default {
    name    :   'ProductSideMenu',
    props   :   ['title', 'menu', 'upper'],
    methods :   {
        make_url(slug)
        {
            return {
                path: this.$route.path,
                query: {
                    category: slug
                }
            };
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/ProductSideMenu.vue